import { CreateAxiosOptions, axiosTransform } from './axiosTransform'
import { AxiosProxy } from './axios'
import { merge } from '@/utils/merge'
import { ContentType } from '@/enums/httpEnum'
import { useGlobalSettings } from '@/composables/useGlobalSettings'
const { urlPrefix, baseURL } = useGlobalSettings()
function createAxios(opts?: Partial<CreateAxiosOptions>) {
  return new AxiosProxy(
    merge(
      {
        baseURL,
        authenticationScheme: '',
        timeout: 300 * 1000,
        headers: { 'Content-Type': ContentType.JSON },
        // 数据处理方式
        transform: axiosTransform,
        // 配置项，下面的选项都可以在独立的接口请求中覆盖
        requestOptions: {
          // 默认将prefix 添加到url
          joinPrefix: true,
          // 是否返回原生响应头 比如：需要获取响应头时使用该属性
          isReturnNativeResponse: false,
          // 需要对返回数据进行处理
          isTransformResponse: true,
          // 格式化提交参数时间
          formatDate: true,
          // 消息提示类型
          errorMessageMode: 'message',
          //  是否加入时间戳
          joinTime: true,
          // 忽略重复请求
          ignoreCancelToken: false,
          // 是否携带token
          withToken: true,
          urlPrefix,
        },
      },
      opts || {},
    ),
  )
}

export default createAxios()
